import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { StyledRow } from './styled'
import { H3, P } from '../../../components'
import { push } from '../../../actions/router'
import { ICapability } from '../../../types/capability'

export interface ICapabilitiesTableRowComponent {
  capability: ICapability
  dispatch: Dispatch
}
export const CapabilitiesTableRowComponent = ({
  capability,
  dispatch,
}: ICapabilitiesTableRowComponent) => (
  <StyledRow
    onClick={() =>
      dispatch(push(`/settings/capabilities/${capability.id}?tab=details`))
    }
  >
    <td>
      <H3>{capability.title}</H3>
    </td>
    <td>
      <P>{capability.description}</P>
    </td>
    <td>
      <P>
        {capability.editionTypes &&
          capability.editionTypes.length > 0 &&
          capability.editionTypes.join(', ')}
      </P>
    </td>
    <td>
      <P>
        {capability.publishingLocation && capability.publishingLocation.title}
      </P>
    </td>
    <td>
      <P>
        {capability.promotionLevel &&
          capability.promotionLevel.length > 0 &&
          capability.promotionLevel.join(', ')}
      </P>
    </td>
    <td>
      <P>{capability.requiredMediaTypeGroupTitle}</P>
    </td>
    <td>
      <P>{capability.supportedMediaTypeGroupTitle}</P>
    </td>
  </StyledRow>
)

export const CapabilitiesTableRow = connect()(CapabilitiesTableRowComponent)
